module.exports = __webpack_public_path__ + "img/01.b7700395.png";